module.exports = __webpack_public_path__ + "static/media/10 copy.808f9732.jpg";